import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(web)/contact/page.tsx");
